import type { CarouselItem } from '../Carousel.svelte';
import { Modifier } from './Modifier';

export interface TranslatorOptions {
	mode: 'endless' | 'boxed' | 'auto'; // Auto is still on the todo
}

export class Translator extends Modifier {
	private readonly options: TranslatorOptions;
	constructor(options: Partial<TranslatorOptions> = {}) {
		super();
		this.options = {
			mode: 'endless',
			...options
		};
		this.lifeCycle.register(this);
	}

	public async start() {
		this.update();
		window.addEventListener('resize', this.update);
	}
	public async stop() {
		window.removeEventListener('resize', this.update);
	}

	private update = () => {
		if (this.options.mode === 'endless') {
			this.controller.setContraints({
				maxX: Number.MAX_SAFE_INTEGER,
				minX: Number.MIN_SAFE_INTEGER,
				maxY: Number.MAX_SAFE_INTEGER,
				minY: Number.MIN_SAFE_INTEGER
			});
		} else {
			const offsetWidth = this.connection.containerElement?.offsetWidth ?? 0;
			this.controller.setContraints({
				maxX: 0,
				minX: -(this.state.totalSize - offsetWidth),
				minY: 0,
				maxY: 0
			});
		}
	};

	public effect() {
		if (this.options.mode === 'endless') {
			this.translateEndless();
		} else {
			this.translate();
		}
	}

	private translateEndless() {
		const containerWidth = this.connection.containerElement?.offsetWidth ?? 0;
		const drag = this.state.boundedDrag;

		let loopedWidth = 0;
		this.state.items.forEach((item: CarouselItem<any>) => {
			const itemWidth = item.node.offsetWidth;
			let targetX = loopedWidth + drag + this.state.gap * item.index;
			loopedWidth += itemWidth;

			while (targetX > containerWidth) {
				targetX -= this.state.totalSize;
			}
			while (targetX < -itemWidth) {
				targetX += this.state.totalSize;
			}

			item.moveTo(targetX);
		});
	}

	private translate() {
		let loopedWidth = 0;
		this.state.items.forEach((item: CarouselItem<any>) => {
			const itemWidth = item.node.offsetWidth;
			const targetX = loopedWidth + this.state.drag + this.state.gap * item.index;
			loopedWidth += itemWidth;

			item.moveTo(targetX);
		});
	}
}
